<template>
    <Content :key="keyComponent">
        <label for="fractional_quantity_product">Peso:</label>
        <div>
            <button @click="setQuantityMinus" aria-label="Diminuir quantidade">
                <i class="fas fa-minus"></i>
            </button>
            <label>
                <input
                    type="text"
                    id="fractional_quantity_product"
                    name="fractional_quantity_product"
                    :value="quantityLabel"
                    @blur="onBlurMinimumQuantity($event.target.value)"
                />
            </label>
            <button @click="setQuantityPlus" aria-label="Aumentar quantidade">
                <i class="fas fa-plus"></i>
            </button>
        </div>
    </Content>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Content } from "./style";
import { formatDecimal } from "../../../helpers/format";
import { swall } from "../../../services/sweetAlert";

export default {
    name: "ProductFractionalSale",
    components: {
        Content
    },
    data() {
        return {
            keyComponent: 0
        };
    },
    methods: {
        ...mapActions("products", ["setQuantityFractional"]),
        setQuantityMinus() {
            if (
                this.quantityFractional ==
                Number(this.minimumQuantityFractional)
            ) {
                swall(
                    `Quantidade mínima de ${this.minimumQuantityFractional} ${this.item.fractional_label}!`
                );
                return;
            }
            this.setQuantityFractional(
                this.quantityFractional -
                    Number(this.item.fractional_conversion_factor)
            );
        },
        setQuantityPlus() {
            let max = Number(this.item.fractional_maximum_sale);
            let qtd =
                this.quantityFractional +
                Number(this.item.fractional_conversion_factor);
            if (this.quantityFractional == max || qtd > max) {
                swall(
                    `Quantidade máxima de ${max} ${this.item.fractional_label}!`
                );
                return;
            }
            this.setQuantityFractional(qtd);
        },
        onBlurMinimumQuantity(v) {
            let qtd = Number(formatDecimal(v));
            let max = Number(this.item.fractional_maximum_sale);
            let factor = Number(this.item.fractional_conversion_factor);

            if (qtd > max) {
                swall(
                    `Quantidade máxima de ${max} ${this.item.fractional_label}!`
                );
                this.keyComponent++;
                return;
            }

            if (qtd < Number(this.minimumQuantityFractional)) {
                swall(
                    `Quantidade mínima de ${this.minimumQuantityFractional} ${this.item.fractional_label}!`
                );
                this.keyComponent++;
                return;
            }

            let mod = Number((qtd % factor).toFixed(2));

            if (mod == 0) {
                this.setQuantityFractional(qtd);
                return;
            }

            if (factor - mod <= mod) {
                qtd += factor - mod;
            } else {
                qtd -= mod;
            }

            this.setQuantityFractional(qtd);
            this.keyComponent++;
        }
    },
    computed: {
        ...mapState("products", [
            "item",
            "quantityFractional",
            "minimumQuantityFractional"
        ]),
        quantityLabel() {
            return `${this.quantityFractional} ${this.item.fractional_label}`;
        }
    }
};
</script>
